"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _MarkdownHtml = _interopRequireDefault(require("./MarkdownHtml"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _constants = require("../constants");

var DisplayLabelContainer = _styledComponents["default"].div.withConfig({
  displayName: "InputLabel__DisplayLabelContainer",
  componentId: "zz8af7-0"
})(["font-size:14px;padding-bottom:8px;color:", ";", ";", ";"], function (props) {
  if (props.labelStyle === "light") {
    return "#FFF";
  } else if (props.labelStyle === "dark") {
    return "#111";
  } else if (props.labelStyle === "gray") {
    return "#333333";
  } else if (props.labelStyle === "black") {
    return "#000";
  } else {
    return "#395865";
  }
}, function (props) {
  return props.labelStyle === "achievement" && (0, _styledComponents.css)(["font-family:'Karla',Helvetica,Arial,sans-serif;text-transform:uppercase;color:#0c0c0c;"]);
}, function (props) {
  return props.displayAfter === true && (0, _styledComponents.css)(["width:100%;display:block';"]);
});

var LabelClassname = _styledComponents["default"].div.withConfig({
  displayName: "InputLabel__LabelClassname",
  componentId: "zz8af7-1"
})(["margin:0 0 -6px 0;", ";"], function (props) {
  return props.fieldIsRequired && (0, _styledComponents.css)(["p:first-child:before{content:'* ';}"]);
});

var Label = _styledComponents["default"].label.withConfig({
  displayName: "InputLabel__Label",
  componentId: "zz8af7-2"
})(["display:block;"]);

var InputLabel = function InputLabel(_ref) {
  var labelFor = _ref.labelFor,
      displayAfter = _ref.displayAfter,
      labelStyle = _ref.labelStyle,
      label = _ref.label,
      children = _ref.children,
      style = _ref.style,
      required = _ref.required,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["labelFor", "displayAfter", "labelStyle", "label", "children", "style", "required"]);

  if (label && label.length >= 1) {
    return /*#__PURE__*/_react["default"].createElement(Label, {
      htmlFor: labelFor || label
    }, displayAfter ? children : null, /*#__PURE__*/_react["default"].createElement(DisplayLabelContainer, rest, /*#__PURE__*/_react["default"].createElement(LabelClassname, {
      fieldIsRequired: required
    }, /*#__PURE__*/_react["default"].createElement(_MarkdownHtml["default"], null, label))), displayAfter ? null : children);
  } else {
    return children ? children : null;
  }
};

InputLabel.propTypes = {
  labelFor: _propTypes["default"].string,
  displayAfter: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  labelStyle: _propTypes["default"].oneOf(_constants.TextLabelStyles).isRequired,
  style: _propTypes["default"].object,
  required: _propTypes["default"].bool
};
InputLabel.defaultProps = {
  displayAfter: false,
  labelStyle: "light",
  style: {},
  label: "",
  required: false
};
var _default = InputLabel;
exports["default"] = _default;